module.exports = __webpack_public_path__ + "static/media/gryphon-house-transform-2.59711f2b.jpeg";